import React from 'react';
import { PageContentContainerType } from '../../PageContentContainer';
import { VerticalType, PageType } from '../types';
import { SortAndFilterLayout } from './SortAndFilterPanel/SortAndFilterLayout';
import {
  ComponentPrefiledBlock,
  UrlPrefixEnum,
} from '$/(cms)/_modules/cmsService/types';
import { CmsPageAddressFlags } from '$/(cms)/_modules/routing';

type PrefilledBlockProps = ComponentPrefiledBlock & {
  vertical?: VerticalType;
  slug?: string;
  host?: string;
  pageType: PageType;
  ContentContainer?: PageContentContainerType;
  urlPrefix?: UrlPrefixEnum;
  addressFlags?: CmsPageAddressFlags;
};

export const PrefilledBlock: React.FC<PrefilledBlockProps> = ({
  block,
  vertical,
  slug,
  pageType,
  ContentContainer,
  urlPrefix,
  addressFlags,
}) => {
  return (
    // A pass-through here — a Block's zone cannot hold a panel — but the
    // page-level provider above stays in scope. No `baseComponents`: a nested
    // block resolves its ProductMetaConfig and Table of Contents against this
    // block's own list, exactly as it did before this ticket.
    <SortAndFilterLayout
      slug={slug}
      pageType={pageType}
      vertical={vertical}
      components={block?.default_components?.filter((c) => !!c) ?? []}
      ContentContainer={ContentContainer}
      urlPrefix={urlPrefix}
      addressFlags={addressFlags}
    />
  );
};
